var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Stamp'),_c('div',{attrs:{"id":"app"}},[_c('main-to-do')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }